import type { Session } from 'next-auth';
import axios from 'axios';
import { apiConfig } from '@/config/api';

export const api = axios.create({ baseURL: apiConfig.baseURL });
export const nextAPI = axios.create({
  baseURL: `${apiConfig.nextBaseURL}/api`,
});
export const comparatorAPI = axios.create({
  baseURL: apiConfig.comparatorBaseURL,
});
export const fpAPI = axios.create({ baseURL: apiConfig.fpBaseURL });

const authClients = [api, fpAPI];

export const setApiAuthSession = (session: Session | null) => {
  const headers = buildAuthHeaders(session);

  authClients.forEach((client) => {
    Object.entries(headers).forEach(([key, value]) => {
      client.defaults.headers.common[key] = value;
    });
  });
};

export const buildAuthHeaders = (session: Session | null) => {
  const headers: Record<string, string> = {};
  if (session?.access_token) {
    headers['Authorization'] = `Bearer ${session.access_token}`;
  }

  if (session?.user) {
    headers['x-eqi-customer-id'] = session.user.auth_id || '';
    headers['x-eqi-customer-document'] = session.user.document;
  }
  return headers;
};
